import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import { FlexBoxProps, FlexGrowRow, FlexRow } from '@xylabs/sdk-react'
import { CoinSponsorStatus, XyoWorldGeotokenSettingsClient } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { FaAngleDown } from 'react-icons/fa'

import { GeotokenSettingsProvider, useGeotokenSettings } from '../../../Contexts'
import { GeotokenSettingsDetails } from './Settings'

const getNote = (settings?: XyoWorldGeotokenSettingsClient) => {
  switch (settings?.getCoinSponsorStatus()) {
    case CoinSponsorStatus.Incomplete:
      return '[Incomplete - Not Active]'
    case CoinSponsorStatus.Disapproved:
      return '[Disapproved - Not Active]'
    default:
      return ''
  }
}

const InnerSettingsAccordion: React.FC<FlexBoxProps> = (props) => {
  const settings = useGeotokenSettings()

  const note = getNote(settings)

  return (
    <FlexRow paper {...props}>
      <Accordion style={{ flexGrow: 1 }}>
        <AccordionSummary>
          <FlexGrowRow justifyContent="space-between">
            <Box display="flex">
              <Typography variant="caption">Geotoken Settings</Typography>
              <Box marginX={1}>
                <Typography color="error" variant="caption">
                  {note}
                </Typography>
              </Box>
            </Box>
            <FaAngleDown />
          </FlexGrowRow>
        </AccordionSummary>
        <AccordionDetails>
          <GeotokenSettingsDetails />
        </AccordionDetails>
      </Accordion>
    </FlexRow>
  )
}

const SettingsAccordian: React.FC<FlexBoxProps> = (props) => {
  return (
    <GeotokenSettingsProvider>
      <InnerSettingsAccordion {...props} />
    </GeotokenSettingsProvider>
  )
}

export default SettingsAccordian
